"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var browser_bundle_service_1 = __importDefault(require("./browser-bundle-service"));
exports.browserBundleService = new browser_bundle_service_1.default();
exports.default = {
    browserBundleService: exports.browserBundleService,
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/country-picker/~/@flowio/browser-bundle/dist/index.js
// module id = 544
// module chunks = 0 1